import {priority, common} from '@priority-software/priority-proto-api/lib';
import {getOrigValue} from './utils';

export type fieldValue = string | boolean | null;

export class Field {
    origValue: fieldValue;
    columnId: number;
    Value: common.IConstant | null;
    currentValue: fieldValue = null;

    constructor(col, properties: priority.netitems.form.IField) {
        this.columnId = Number(properties.ColumnID);
        this.Value = properties.Value;
        this.origValue = getOrigValue(properties.Value, col);
        this.currentValue = this.origValue;
    }

    setCurrentValue = (value: fieldValue) => {
        this.currentValue = value;
    };
}
